import React from 'react'
import { Stepper, Step, StepButton } from '@material-ui/core'

export default class CreateStep extends React.Component {
  render() {
    const { activeStep, maxStep, setFormStep, requirePQ } = this.props

    const handleStep = (step, maxStep, setFormStep) => {
      if (step <= maxStep) {
        setFormStep(step)
      }
    }

    return (
      <Stepper style={{ marginTop: '10px' }} nonLinear activeStep={activeStep}>
        <Step>
          <StepButton
            completed={activeStep >= 1}
            onClick={() => handleStep(1, maxStep, setFormStep)}>
            Short List Information
          </StepButton>
        </Step>
        {
          requirePQ ? 
            <Step>
              <StepButton
                completed={activeStep >= 2}
                onClick={() => handleStep(2, maxStep, setFormStep)}>
                Pre-Q
              </StepButton>
            </Step> : null
        }
        <Step>
          <StepButton
            completed={activeStep >= (requirePQ ? 3 : 2)}
            onClick={() => handleStep((requirePQ ? 3 : 2), maxStep, setFormStep)}>
            Committee Approval
          </StepButton>
        </Step>
        <Step>
          <StepButton
            completed={activeStep >= (requirePQ ? 4 : 3)}
            onClick={() => handleStep((requirePQ ? 4 : 3), maxStep, setFormStep)}>
            Action for Approval
          </StepButton>
        </Step>
      </Stepper>
    )
  }
}